import React, { memo } from 'react'
import { Avatar } from '@mui/material'

const ProviderIcon = ({ src, icon, size = 64, sx, noBorder = false }) => {
  return (
    <Avatar
      sx={{
        width: size,
        height: size,
        // mx: 'auto',
        ...(!noBorder && { border: '1px solid' }),
        ...sx
      }}
      slotProps={{
        img: {
          loading: 'lazy'
        }
      }}
      src={src}
    >
      {icon && icon}
    </Avatar>
  )
}

export default memo(ProviderIcon)
